export default "__VITE_ASSET__0f610295__"